// Família do método de saque (ENG-868).
//
// A pergunta que o fluxo faz o tempo todo não é "qual gateway?", e sim "que
// dado eu preciso pedir ao jogador?" — chave Pix, conta bancária mexicana,
// telefone. Vários gateways compartilham a mesma resposta.
//
// Antes disso, a lista de gateways Pix vivia hardcoded num computed de
// components/withdraw/index.vue (`withdrawMethodIsPix`, 13 comparações
// encadeadas). Aqui a relação é invertida de propósito: mapeamos as famílias
// pequenas e fechadas, e tudo que sobra é Pix. Assim um gateway brasileiro
// novo (a lista cresce a cada integração) já nasce funcionando, em vez de cair
// silenciosamente fora do fluxo de Pix como acontecia antes.

export type WithdrawFamily =
  | 'pix'
  | 'bank-mx'
  | 'phone'
  | 'crypto'
  | 'worldline';

const BANK_MX_METHODS: PaymentsMethodsType[] = ['spei', 'oxxo'];

const PHONE_METHODS: PaymentsMethodsType[] = ['astropay'];

export function withdrawMethodFamily(
  slug?: PaymentsMethodsType,
): WithdrawFamily {
  if (!slug) return 'pix';

  if (BANK_MX_METHODS.includes(slug)) return 'bank-mx';
  if (PHONE_METHODS.includes(slug)) return 'phone';
  if (slug === 'crypto') return 'crypto';
  if (slug === 'worldline') return 'worldline';

  return 'pix';
}

export function isPixWithdrawMethod(slug?: PaymentsMethodsType): boolean {
  return withdrawMethodFamily(slug) === 'pix';
}
